module.exports = __webpack_public_path__ + "assets/img/qr_code.dfbb384b.png";